import { IssueTranslationKeys } from 'intl/keys';
import { TranslationKey } from 'intl/types/translationKey';
import { LastDecisionStatus } from 'shared/domain/workflow/lastDecisionStatus';

const ISSUE_LAST_DECISION_STATUS_LABEL_KEYS: Record<
  LastDecisionStatus,
  TranslationKey
> = {
  [LastDecisionStatus.APPROVED]: IssueTranslationKeys.lastDecisionApproved,
  [LastDecisionStatus.REJECTED]: IssueTranslationKeys.lastDecisionRejected,
  [LastDecisionStatus.NONE]: IssueTranslationKeys.lastDecisionNone,
};

export function issueLastDecisionStatusLabelKey(
  status: LastDecisionStatus
): TranslationKey {
  return ISSUE_LAST_DECISION_STATUS_LABEL_KEYS[status];
}
